<template>
  <div class="field">
    <label class="label">Max Seniority</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'PositionMaxSeniority',
  props: {
    value: {
      type: [Number],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  data () {
    return { saveSeq: 0 }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    // save-start / saved / save-failed carry a per-save `seq` so the parent can
    // tell which value the server last confirmed (re-checked-maximum status).
    async handleChange () {
      const seq = ++this.saveSeq
      const value = this.value
      this.$emit('save-start', { seq, value })
      try {
        const response = await this.$network_utils.updatePosition({ position_id: this.positionId, max_seniority: value })
        this.$utils.emit('show_toast', { text: 'Success' })
        this.$emit('saved', { seq, value, response })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
        this.$emit('save-failed', { seq, value })
      }
    }
  }
}
</script>
